import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
  Alert,
  Form,
  Label,
  Row,
  Input,
  FormGroup,
  ButtonGroup,
  Button,
  Card,
  CardBody,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';

import {
  getDetailSubcategories,
  saveSubcategories,
  deleteSubcategories,
  newSubcategories
} from '../../actions/subcategoriesAction';
import { getOptionList as getCategoryOptionList } from '../../actions/categoriesAction';
import { ValidationMessage } from '../../components/Form/ValidationMessage';

class SubcategoriesForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _hasId: !!this.props.match.params.id,
      _form: {
        binding: false,
        id: this.props.match.params.id,
        name: '',
        category_id: '',
        active: true,
        created_at: '',
        updated_at: ''
      },
      _formSubmit: false,
      _modalDelete: false,
      _redirect: false
    };
  }

  componentWillMount() {
    if (!this.props.masterCategories.options.length) {
      this.props.bindCategoryOption();
    }
    this.props.new();
    if (this.state._hasId)
      this.props.find(this.state._form.id);
  }

  componentWillUpdate(nextProps) {
    const { detail, isFetch, isSubmit, error, success } = nextProps.masterSubcategories;

    if (this.state._redirect) return;

    if (detail.delete) {
      this.setState({ _redirect: true });
      return;
    }

    if (error && error.status_code === 404) {
      this.setState({ _redirect: true });
      return;
    }

    if (this.state._hasId) {
      if (detail.id && error === null) {
        if (!isFetch && !this.state._form.binding) {
          const _form = { ...this.state._form, binding: true };
          this.setState({ _form }, () => {
            const _newForm = { ...this.state._form, ...detail };
            this.setState({ _form: _newForm });
          });
        } else if (!isSubmit && this.state._formSubmit && success) {
          this.setState({ _redirect: true });
        }
      }
    } else {
      if (success && this.state._formSubmit && !isSubmit) {
        this.setState({ _redirect: true });
      }
    }
  }

  handleChange(e) {
    const newState = { ...this.state._form };
    newState[e.target.name] = e.target.value;
    this.setState({ _form: newState });
  }

  handleCheckedChange(e) {
    const newState = { ...this.state._form };
    newState[e.target.name] = e.target.checked;
    this.setState({ _form: newState });
  }

  onSubmit(e) {
    e.preventDefault();
    this.setState({ _formSubmit: true }, () => {
      const { id, name, category_id, active } = this.state._form;
      this.props.save({ id, name, category_id, active });
    });
  }

  toggle() {
    this.setState({ _modalDelete: !this.state._modalDelete });
  }

  onDelete() {
    this.props.delete(this.state._form.id);
    this.toggle();
  }

  renderLoading() {
    return (
      <div className="row">
        <div className="col-sm-12">
          <Alert color="info" className="text-center">Getting all data...</Alert>
        </div>
      </div>
    );
  }

  renderInfo() {
    const infoMessage = [];
    const { isSubmit, success, error } = this.props.masterSubcategories;
    if (isSubmit)
      infoMessage.push(
        <Alert color="info" key="info"><strong>Heads up!</strong> Submitting...</Alert>
      );
    if (success)
      infoMessage.push(
        <Alert color="success" key="success"><strong>Well done!</strong> {success}</Alert>
      );
    if (error !== null) {
      const { status_code, message } = error;
      switch (status_code) {
        case 422:
          infoMessage.push(
            <Alert color="danger" key="error"><strong>Oh Snap!</strong> Please fullfill your form. </Alert>
          );
          break;
        case 404:
          infoMessage.push(
            <Alert color="danger" key="error"><strong>Oh Snap!</strong> Resource not found. </Alert>
          );
          break;
        default:
          infoMessage.push(
            <Alert color="danger" key="error"><strong>Oh Snap!</strong> {message || "We've got something errors"}</Alert>
          );
          break;
      }
    }
    return (
      <div className="row">
        <div className="col-sm-12">
          {infoMessage}
        </div>
      </div>
    );
  }

  validateError(name) {
    if (this.hasError(name)) {
      const errorList = this.props.masterSubcategories.error.errors;
      return <ValidationMessage message={errorList[name][0]} />;
    }
    return '';
  }

  hasError(name) {
    const { error } = this.props.masterSubcategories;
    if (error && error.errors) {
      return Object.keys(error.errors).some(key => key === name);
    }
    return false;
  }

  render() {
    if (this.state._redirect)
      return <Redirect to="/subcategories" />;

    const { isFetch, isSubmit } = this.props.masterSubcategories;
    const { options } = this.props.masterCategories;

    return (
      <Row>
        <Modal isOpen={this.state._modalDelete} toggle={this.toggle.bind(this)} className="modal-dialog modal-sm">
          <ModalHeader toggle={this.toggle.bind(this)}>Confirmation</ModalHeader>
          <ModalBody>
            Are you sure to delete this?
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.onDelete.bind(this)}>Yes</Button>{' '}
            <Button color="secondary" onClick={this.toggle.bind(this)}>Cancel</Button>
          </ModalFooter>
        </Modal>
        <div className="col-md-6 offset-md-3">
          <Card>
            <CardHeader>
              <i className="fa fa-align-justify"></i> {this.props.title}
            </CardHeader>
            <CardBody>
              {this.renderInfo()}
              {isFetch ? this.renderLoading() :
                <Form onSubmit={this.onSubmit.bind(this)}>
                  <FormGroup className={this.hasError('name') ? ' has-danger has-feedback' : ''}>
                    <Label for="formSubcategoryName">Subcategory Name</Label>
                    <Input
                      type="text"
                      id="formSubcategoryName"
                      name="name"
                      placeholder="Enter a name*"
                      maxLength={255}
                      value={this.state._form.name}
                      onChange={this.handleChange.bind(this)}
                    />
                    {this.validateError('name')}
                  </FormGroup>
                  <FormGroup>
                    <Label for="formSubcategoryCategory">Parent Category</Label>
                    <Input
                      type="select"
                      id="formSubcategoryCategory"
                      name="category_id"
                      value={this.state._form.category_id}
                      onChange={this.handleChange.bind(this)}
                    >
                      <option value="">Select a category*</option>
                      {options.map((opt, i) => (
                        <option key={i} value={opt.value}>{opt.label}</option>
                      ))}
                    </Input>
                  </FormGroup>
                  <FormGroup check className="mb-3">
                    <Label check>
                      <Input
                        type="checkbox"
                        name="active"
                        checked={!!this.state._form.active}
                        onChange={this.handleCheckedChange.bind(this)}
                      />{' '}
                      Active
                    </Label>
                  </FormGroup>
                  {this.state._hasId && (
                    <>
                      <FormGroup>
                        <Label>Created At</Label>
                        <Input
                          type="text"
                          readOnly
                          value={this.state._form.created_at || ''}
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label>Updated At</Label>
                        <Input
                          type="text"
                          readOnly
                          value={this.state._form.updated_at || ''}
                        />
                      </FormGroup>
                    </>
                  )}
                  <FormGroup>
                    <ButtonGroup>
                      <Button color="primary" disabled={isSubmit}>Submit</Button>
                      {this.state._hasId &&
                        <Button color="danger" type="button" onClick={this.toggle.bind(this)}>Delete</Button>
                      }
                    </ButtonGroup>
                  </FormGroup>
                </Form>
              }
            </CardBody>
          </Card>
        </div>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  masterSubcategories: state.masterSubcategories,
  masterCategories: state.masterCategories
});

const mapDispatchToProps = (dispatch) => ({
  find: (id) => dispatch(getDetailSubcategories(id)),
  delete: (id) => dispatch(deleteSubcategories(id)),
  save: (payload) => dispatch(saveSubcategories(payload)),
  new: () => dispatch(newSubcategories()),
  bindCategoryOption: () => dispatch(getCategoryOptionList())
});

export default connect(mapStateToProps, mapDispatchToProps)(SubcategoriesForm);
